import type {
  FieldType,
  HttpMethod,
  HttpStatusCode,
} from "@/features/Projects/models/project.types";

export const FIELD_TYPES: FieldType[] = [
  "string",
  "number",
  "boolean",
  "date",
  "datetime",
  "email",
  "url",
  "uuid",
  "json",
  "text",
  "enum",
  "array",
  "object",
  "reference",
];

export const FIELD_TYPE_OPTIONS = FIELD_TYPES.map((type) => ({
  value: type,
  label: type.charAt(0).toUpperCase() + type.slice(1),
  disabled: false,
}));

export const HTTP_METHODS: HttpMethod[] = ["GET", "POST", "PUT", "PATCH", "DELETE"];

export const HTTP_METHOD_OPTIONS = HTTP_METHODS.map((method) => ({
  value: method,
  label: method,
  disabled: false,
}));

export const HTTP_STATUS_CODES: HttpStatusCode[] = [
  200, 201, 204, 400, 401, 403, 404, 422, 500,
];

export const HTTP_STATUS_OPTIONS = HTTP_STATUS_CODES.map((code) => ({
  value: code.toString(),
  label: `${code} - ${getStatusText(code)}`,
  disabled: false,
}));

export const PARAMETER_TYPES = ["path", "query", "header", "body"] as const;

export const PARAMETER_TYPE_OPTIONS = PARAMETER_TYPES.map((type) => ({
  value: type,
  label: type.charAt(0).toUpperCase() + type.slice(1),
  disabled: false,
}));

export function getStatusText(code: HttpStatusCode): string {
  const statusTexts = {
    200: "OK",
    201: "Created",
    204: "No Content",
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    422: "Unprocessable Entity",
    500: "Internal Server Error",
  };
  return statusTexts[code] || "Unknown";
}